<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="F10" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r5l2mzxvj31hc0rt0u2.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1gh5ur60208j30u01b8q5u.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1gh5vzc4g5dj31hc0800tc.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gh5w8m799rj30u00fswfv.jpg"/>
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation">
            <swiper :options="swiperOption">
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
            </swiper>
        </div>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1gh5vxeugyzj31hc03lweg.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gh5w6qd1gkj30u007ogls.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5r5l3hgu7j31hc0rv76f.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g5r5l4jk7xj31hc0rrwhx.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1gdwjcebzj0j31hc0ruac1.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1gdwjc7nyxyj31hc0rsjsx.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5r5l767ucj31hc0rtam4.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5r5l7spixj31hc0rt40l.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1gh5v2qfz0yj31hc0kotay.jpg"/>
        
        
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gh5urb5uc0j30u01b8jws.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gh5urgghpnj30u01b8gt8.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1gh5uriyu3sj30u01b80w3.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1gh5urtqzzej30u01b8q6k.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gh5urwdaswj30u01b8tu3.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1gh5urz2ps9j30u01b8tba.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1gh5us1j9pdj30u01jkadx.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 0,
            earphones: ["https://wx4.sinaimg.cn/large/0067mezugy1gh5v5yt7e2j30ak0epabe.jpg", "https://wx4.sinaimg.cn/large/0067mezugy1gh5v6306dyj30al0epmyx.jpg", "https://wx4.sinaimg.cn/large/0067mezugy1gh5v65kn9wj30am0eqgnm.jpg"],
            
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    }
}
</script>
<style scoped>

.pro_animation .swiper-container{
    margin-top: 30px;
}

@media (max-width: 768px){
    .pro_animation_item img{
        width: 60%;
        height: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/products/F/f10.vue